import { connect } from 'react-redux';
import ErrorBoundary from './error-boundary';

const mapStateToProps = state => ({
  errors: state.errors,
  account: state.account,
  mainPage: state.account.defaultPage,
  id: state.account.id
});

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorBoundary);
